module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', [_c('p', {
    staticClass: "fm_head"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix",
      "title": "ix"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_x",
      "title": "x"
    }
  }, [_c('b', [_vm._v("Contents")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rcover"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062973368_Cover#cover"
    }
  }, [_c('i', [_vm._v("Cover")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rtit"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062973368_Titlepage#tit"
    }
  }, [_c('i', [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rded"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062973368_Dedication#ded"
    }
  }, [_c('i', [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fmb",
    attrs: {
      "id": "repi"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062973368_Epigraph#epi"
    }
  }, [_c('i', [_vm._v("Epigraph")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rintro"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062973368_Introduction#intro"
    }
  }, [_vm._v("Introduction: The Death of an Age")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062973368_Chapter_01#ch1"
    }
  }, [_vm._v("Chapter 1: An Attack on a Newspaper")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rch2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062973368_Chapter_02#ch2"
    }
  }, [_vm._v("Chapter 2: Showering Twice a Month")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062973368_Chapter_03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: The Globalization Wars")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062973368_Chapter_04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: The Land of the Last Elephants")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062973368_Chapter_05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: “We Refuse to Die”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062973368_Chapter_06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: The Rebellion’s Harbingers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062973368_Chapter_07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Talking with Nationalists")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062973368_Chapter_08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: A Nazi Revival")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062973368_Chapter_09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: The Middle-Class Mutinies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rch10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062973368_Chapter_10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Anarchists with Ferraris")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062973368_Chapter_11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Disappearing Children")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rch12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062973368_Chapter_12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: “Humankind Is the "), _c('i', [_vm._v("Titanic")]), _vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rch13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062973368_Chapter_13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Faces of Exodus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rch14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062973368_Chapter_14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: An Experiment and Its Costs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rch15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062973368_Chapter_15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Rivers of Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rch16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062973368_Chapter_16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: A Subject of the Empire Speaks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rch17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062973368_Chapter_17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: “My Mother Was Murdered Here”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rch18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062973368_Chapter_18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: The Anti-Globalizer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rch19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062973368_Chapter_19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: The Implosion of Truth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rch20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062973368_Chapter_20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: The Battle for Progress")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rch21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062973368_Chapter_21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: A New Story")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bm_ts",
    attrs: {
      "id": "rack"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062973368_Acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bm",
    attrs: {
      "id": "rnote"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062973368_Notes#note",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bm",
    attrs: {
      "id": "rind"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062973368_Index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bm",
    attrs: {
      "id": "rata"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Author#ata",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bm",
    attrs: {
      "id": "rcopy"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062973368_Copyright#copy",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Copyright")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bm",
    attrs: {
      "id": "ratp"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Publisher#atp",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Publisher")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d52e51e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062973368_Contents.vue
// module id = 69
// module chunks = 0